import { Font } from 'themes/interfaces';

export default {
  xxxs: 10,
  xxs: 12,
  xs: 14,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
  xxl: 48,
  xxxl: 64,
  thin: '100',
  extraLight: '200',
  light: '300',
  normal: '400',
  medium: '500',
  semiBold: '600',
  bold: 'bold',
  extraBold: '800',
  black: '900',
} as Font;
